import React, { useContext, useEffect, useRef } from 'react';

import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Tooltip,
	Paper,
	IconButton,
	Button
} from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import EditParamFormCB5 from '../EditParamFormCB5';
import { store } from '../store';
import { Route, withRouter } from 'react-router-dom';
import { css } from '@emotion/react';
import { ROUTE_BASE_APPS } from './vars';
import AddIcon from '@mui/icons-material/Add';

/* const tableScrollStyle = css({
	border: '1px solid red',
	display: 'flex',
	flex: 1,
	flexDirection: 'column',
	padding: '8px'
	//width: '820px',

	//overflowY: 'auto'
});

const cellStyle = css({
	backgroundColor: 'black',
	color: 'white',
	padding: '4px',
	textAlign: 'center',
	borderRadius: '4px'
}); */

function useEditParam(state, match, dispatch, history) {
	function onClose() {
		history.goBack();
	}

	useEffect(() => {
		if (state.fullScreenDialog.open) return;

		dispatch({
			type: 'open dialog',
			dlgCmp: (
				<EditParamFormCB5
					match={match}
					history={history}
					onClose={onClose}
				/>
			)
		});
	}, [match.params.id]);
}
const PopEditDialog = withRouter(({ match, history }) => {
	const { state, dispatch } = useContext(store);
	useEditParam(state, match, dispatch, history);
	return <div>{JSON.stringify(match)}</div>;
});

const EditParamRoute = () => (
	<Route
		path={`${ROUTE_BASE_APPS}/:appID/settings/all/:id`}
		strict
		render={props => <PopEditDialog {...props} />}
	/>
);

const AppParamTable = withRouter(({ data, match, history }) => {
	const baseRouteRef = useRef(match.url);
	function openEditParameter({ id }) {
		history.push(`${baseRouteRef.current}/${id}`);
	}

	return (
		<div css={css({ display: 'flex', flexDirection: 'column' })}>
			<Button
				sx={{ marginLeft: 'auto' }}
				variant="outlined"
				onClick={e => history.push(`${baseRouteRef.current}/0`)}>
				<AddIcon />
			</Button>
			<TableContainer component={Paper}>
				<Table id="content" aria-label="Params">
					<TableHead>
						<TableRow>
							<TableCell scrollElement=".scrollContainer">
								ID
							</TableCell>
							<TableCell
								scrollElement=".scrollContainer"
								align="right">
								PARAM
							</TableCell>
							<TableCell
								scrollElement=".scrollContainer"
								align="right">
								VALUE
							</TableCell>
							<TableCell
								scrollElement=".scrollContainer"
								align="right">
								TYPE
							</TableCell>
							<TableCell
								scrollElement=".scrollContainer"
								align="right">
								ORG NAME
							</TableCell>
							<TableCell
								scrollElement=".scrollContainer"
								align="right">
								ACTIONS
							</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{data.map(row => (
							<TableRow
								key={row.id}
								sx={{
									'&:last-child td, &:last-child th': {
										border: 0
									}
								}}>
								<TableCell component="th" scope="row">
									{row.id}
								</TableCell>
								<TableCell align="right">{row.param}</TableCell>
								<TableCell
									sx={{
										whiteSpace: 'nowrap',
										maxWidth: '120px',
										textOverflow: 'ellipsis',
										overflow: 'hidden'
									}}
									align="right">
									<Tooltip
										title={row.value}
										followCursor
										sx={{ position: 'absolute' }}>
										<span>{row.value}</span>
									</Tooltip>
								</TableCell>
								<TableCell align="right">{row.type}</TableCell>
								<TableCell align="right">
									{row.org_label}
								</TableCell>
								<TableCell align="right">
									<IconButton
										size="small"
										aria-label="open"
										color="primary"
										onClick={e => openEditParameter(row)}>
										<EditIcon />
									</IconButton>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
			<EditParamRoute />
		</div>
	);
});

export default AppParamTable;
